import { useState } from "react";
import { useAtom } from "@dbeining/react-atom";
import { userAtom } from "../../atoms/userAtom";
import { showToastSuccess, showToastError } from "../../utils";
import { calendarEventService, emailTemplateService } from "../../services";
import mapEmailBody from "../../pages/Task/Mapping";
import { useEmailTemplate } from "../useEmailTemplate";
import { IEvent } from "../../components/features/calendar/EventCalendar";

export const useEventRemove = (eventToBeUpdated?: IEvent) => {
  const [alertVariant, setAlertVariant] = useState("danger");
  const currentUser = useAtom(userAtom);
  const actioner = `${currentUser?.identity.displayName}: ${currentUser?.identity.email}`;
  
  const { emailTemplate, eventTemplate, createEmailArray } = useEmailTemplate("Event Delete");

  const handleSubmit = async (values: any, { setStatus, setSubmitting }: any) => {
    setStatus();
    setSubmitting(true);
    
    try {
      const response = await calendarEventService.remove(eventToBeUpdated?.groupId ?? "");
      setSubmitting(false);
      
      if (response.status !== "Failure") {
        // Send emails
        const personals = eventToBeUpdated?.associatedIds?.map((id: string) => ({
          email: id, // This might need adjustment based on your data structure
        })) ?? [];
        
        const receiverEmails = await createEmailArray(eventTemplate, personals, currentUser?.identity.email ?? "");
        const eventId = eventToBeUpdated?.groupId ?? "";
        const updatedBody = await mapEmailBody({ 
          body: emailTemplate.body, 
          id: eventId, 
          actioner: actioner 
        });
        const updatedSubject = await mapEmailBody({ 
          body: emailTemplate.subject, 
          id: eventId, 
          actioner: actioner 
        });
        
        if (receiverEmails?.length > 0) {
          await emailTemplateService.sendAutoEmail(updatedSubject, updatedBody, receiverEmails);
        }
        showToastSuccess("Event removed successfully");
        return true;
      } else {
        setAlertVariant("danger");
        showToastError(response.message);
        return false;
      }
    } catch (error: any) {
      setAlertVariant("danger");
      if (error.status === 400 && error.errors) {
        Object.keys(error.errors).forEach((key) => {
          const messages = error.errors[key];
          if (Array.isArray(messages)) {
            messages.forEach((message) => showToastError(message));
          }
        });
      } else {
        showToastError("Something went wrong. Please try again.");
      }
      setSubmitting(false);
      return false;
    }
  };

  return {
    alertVariant,
    currentUser,
    handleSubmit,
  };
};
